import React from "react";

interface CheckListIconProps {
  className?: string;
  size?: number;
  color?: string; strokeWidth?: number; strokeWidth2?: number;
}

const CheckListIcon: React.FC<CheckListIconProps> = ({
  size = 16,
  color = '#1E1E1E',
}) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.24738 5.91992H11.7474" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.25262 5.91992L4.75262 6.41992L6.25262 4.91992" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.24738 10.5859H11.7474" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.25262 10.5859L4.75262 11.0859L6.25262 9.58594" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.99998 14.6673H9.99998C13.3333 14.6673 14.6666 13.334 14.6666 10.0007V6.00065C14.6666 2.66732 13.3333 1.33398 9.99998 1.33398H5.99998C2.66665 1.33398 1.33331 2.66732 1.33331 6.00065V10.0007C1.33331 13.334 2.66665 14.6673 5.99998 14.6673Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default CheckListIcon;
